import React, { useEffect, useState } from "react";
import cargoTypeService from "../api/cargoTypeService";

const CargoTypePage = () => {
    const [cargoTypes, setCargoTypes] = useState([]);
    const [form, setForm] = useState({ id: null, name: "" });
    const [isEditMode, setIsEditMode] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        fetchCargoTypes();
    }, []);

    const fetchCargoTypes = async () => {
        try {
            setLoading(true);
            const data = await cargoTypeService.getCargoTypes();
            setCargoTypes(Array.isArray(data) ? data : []);
        } catch (err) {
            setError("Failed to load cargo types");
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        try {
            if (isEditMode) {
                await cargoTypeService.updateCargoType(form.id, form);
            } else {
                await cargoTypeService.createCargoType({
                    name: form.name,
                });
            }

            setForm({ id: null, name: "" });
            setIsEditMode(false);
            await fetchCargoTypes();
        } catch (err) {
            setError("Failed to save cargo type");
        }
    };

    const handleEdit = (cargoType) => {
        setForm({
            id: cargoType.id,
            name: cargoType.name,
        });
        setIsEditMode(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Delete this cargo type?")) return;

        try {
            await cargoTypeService.deleteCargoType(id);
            await fetchCargoTypes();
        } catch {
            setError("Failed to delete cargo type");
        }
    };

    const handleCancel = () => {
        setForm({ id: null, name: "" });
        setIsEditMode(false);
    };

    // ================= UI =================

    if (loading) return <p className="text-center">Loading...</p>;

    return (
        <div className="max-w-xl mx-auto p-6 bg-white rounded shadow">
            <h2 className="text-xl font-bold mb-4">Cargo Types</h2>

            {error && (
                <p className="text-red-600 mb-3">{error}</p>
            )}

            {/* FORM */}
            <form onSubmit={handleSubmit} className="mb-6 space-y-2">
                <input
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    placeholder="Cargo Type Name"
                    required
                    className="border rounded p-2 w-full"
                />

                <div className="flex gap-2">
                    <button
                        type="submit"
                        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                    >
                        {isEditMode ? "Update" : "Create"}
                    </button>

                    {isEditMode && (
                        <button
                            type="button"
                            onClick={handleCancel}
                            className="px-4 py-2 border rounded"
                        >
                            Cancel
                        </button>
                    )}
                </div>
            </form>

            {/* LIST */}
            {cargoTypes.length === 0 ? (
                <p className="text-gray-500">No cargo types found</p>
            ) : (
                <ul>
                    {cargoTypes.map((ct) => (
                        <li
                            key={ct.id}
                            className="border-b py-2 flex justify-between items-center"
                        >
                            <span>{ct.name}</span>

                            <div>
                                <button
                                    onClick={() => handleEdit(ct)}
                                    className="text-yellow-500 mr-2"
                                >
                                    Edit
                                </button>

                                <button
                                    onClick={() => handleDelete(ct.id)}
                                    className="text-red-500"
                                >
                                    Delete
                                </button>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default CargoTypePage;